<template>
  <div class="p-6 bg-white rounded-xl shadow-md">
    <h3 class="text-xl font-bold text-purple-600 inline-block transition-all duration-500">
      <span
          class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
         سفارش های در انتظار ارسال
      </span>
    </h3>
    <div class="mt-2 flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
      <div class="flex flex-wrap gap-2">
        <input v-model="filters.id" @input="fetchOrders" type="number"
               placeholder="شماره سفارش"
               class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right">
        <input v-model="filters.search" @input="fetchOrders" type="text"
               placeholder="جستجو"
               class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-30 text-right">
        <select v-model="filters.quick_date_filter" @change="applyQuickDateFilter"
                class="px-3 py-2 bg-gray-100 text-sm rounded-lg border text-right">
          <option value="">فیلتر تاریخ</option>
          <option v-for="(label, key) in quickDateLAbles" :key="key" :value="key">{{ label }}</option>
        </select>

        <date placeholder="از تاریخ" v-model="filters.date_from" @input="fetchOrders"></date>
        <date placeholder="تا تاریخ" v-model="filters.date_to" @input="fetchOrders"></date>
      </div>
      <div>
        <div v-if="showPopup" class="fixed inset-0 z-50 flex items-center justify-center">
          <div
              @click="showPopup = false"
              class="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm"
          ></div>

          <div class=" relative bg-white/90 p-6 rounded-xl shadow-2xl border border-white/20 max-w-xl w-full mx-4">
            <h3 class="text-lg font-bold mb-6 text-gray-800">تایید ارسال سفارشات</h3>
            <p v-if="selected.length > 0" class="mb-3 text-gray-700">آیا از تغییر وضعیت  {{selected.length}} سفارش انتخاب‌شده به «ارسال شده» اطمینان دارید؟</p>
            <p v-if="selected.length > 0" class="mb-3 text-purple-500 animate-pulse font-weight-bold text-h6">این عملیات قابل بازگشت نیست</p>
            <p v-if="selected.length > 0" class=" text-gray-700">آیا مطمئن هستید که می‌خواهید ادامه دهید؟</p>
            <p v-if="selected.length == 0" class=" text-gray-700">حداقل باید یک سفارش انتخاب کنید</p>

            <div class="flex justify-end gap-3">
              <button
                  @click="showPopup = false"
                  class="px-4 py-2 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-100 transition text-gray-700"
              >
                انصراف
              </button>
              <button
                  v-if="selected.length > 0"
                  @click="confirmAction"
                  class="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg hover:shadow-md transition-all hover:scale-[1.02]"
              >
                تایید ارسال سفارشات
              </button>
            </div>
          </div>
        </div>

        <button
            @click="showConfirmation"
            class="bg-purple-500 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          تایید ارسال سفارشات
        </button>
      </div>

      <div class="left-2">
        <button @click="printOrders"
                class="bg-purple-500 hover:bg-purple-700 text-white px-3 py-2 rounded-lg transition-all duration-300 ease-in-out transform hover:hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
          </svg>
        </button>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full table-auto text-right border border-gray-200">
        <thead class="bg-gray-50 text-sm text-gray-700">
        <tr>
          <th class="p-3 border text-[11px]"><input type="checkbox" v-model="selectAll" @change="toggleSelectAll" /></th>
          <th class="p-3 border text-[11px]">تاریخ</th>
          <th class="p-3 border text-[11px]">شماره سفارش</th>
          <th class="p-3 border text-[11px]">کد رهگیری اکسونی</th>
          <th class="p-3 border text-[11px]">وضعیت</th>
          <th class="p-3 border text-[11px]">تعداد اقلام</th>
          <th class="p-3 border text-[11px]">مبلغ سفارش</th>
          <th class="p-3 border text-[11px]">هزینه ارسال</th>
          <th class="p-3 border text-[11px]">مبلغ تخفیف</th>
          <th class="p-3 border text-[11px]">مبلغ کل</th>
          <th class="p-3 border text-[11px]">مشتری</th>
          <th class="p-3 border text-[11px]">نوع پرداخت</th>
          <th class="p-3 border text-[11px]">اکشن</th>
        </tr>
        </thead>
        <tbody class="text-gray-600 text-sm">
        <tr v-for="order in orders" :key="order.id" class="hover:bg-gray-50 transition">
          <td class="p-2 border"><input type="checkbox" v-model="selected" :value="order.id" /></td>
          <td class="p-2 border">{{ order.id }}</td>
          <td class="p-2 border text-[9px]">{{ formatDate(order.date_time) }}</td>
          <td class="p-2 border text-[10px]">{{ order.exuni_tracking_code }}</td>
          <td class="p-2 border">
            <span :class="statusClass(order.status)">
              {{ statusLabels[order.status] || order.status }}
            </span>
          </td>
          <td class="p-2 border">{{ order.total_product_quantity | toMoney }}
            <span class="text-[8px] text-gray-500">عدد</span>
          </td>
          <td class="p-2 border">{{ order.total_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">{{ order.post_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">{{ order.total_discount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">{{ order.final_amount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">
            <span class="text-[12px]">{{order.customer.mobile_number}}</span>
            <span class="m-1 mr-1 text-[8px] text-gray-500">{{order.shipment_address.first_name}}</span>
            <span class="text-[8px] text-gray-500">{{order.shipment_address.last_name}}</span>
          </td>
          <td class="p-2 border text-[10px]">{{ order.payment_display }}</td>
          <td class="p-2 border">
            <button class="text-blue-600 hover:underline text-xs">جزئیات</button>
          </td>
        </tr>

        <!-- Totals Row -->
        <tr class="bg-gray-100 font-bold text-gray-800">
          <td class="p-2 border text-center" colspan="5">جمع کل</td>
          <td class="p-2 border">
            {{ totals.total_product_quantity }}
            <span class="text-[8px] text-gray-500">عدد</span>
          </td>
          <td class="p-2 border">
            {{ totals.total_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">
            {{ totals.post_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">
            {{ totals.total_discount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border">
            {{ totals.final_amount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="p-2 border" colspan="2"></td>
        </tr>

        </tbody>
      </table>
      <div class="flex justify-center items-center mt-4 gap-2">
        <button
            @click="pagination.current_page++; fetchOrders()"
            :disabled="pagination.current_page === 1"
            class="bg-purple-500 text-white p-2 rounded-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse disabled:opacity-50 disabled:transform-none disabled:bg-purple-500"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"  d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <span class="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg">
    {{ pagination.current_page }} از {{ Math.ceil(pagination.total_items / pagination.page_size) }}
  </span>

        <button
            @click="pagination.current_page--; fetchOrders()"
            :disabled="pagination.current_page * pagination.page_size >= pagination.total_items"
            class="bg-purple-500 text-white p-2 rounded-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse disabled:opacity-50 disabled:transform-none disabled:bg-purple-500"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <select
            v-model="pagination.page_size"
            @change="pagination.current_page = 1; fetchOrders()"
            class="bg-gray-500 text-white px-3 py-1 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-300"
        >
          <option value="10" >10</option>
          <option value="20" >20</option>
          <option value="50" >50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow-lg border border-gray-200"
           :class="{
             '!bg-green-50 !border-green-200 !text-green-700': notificationType === 'success',
             '!bg-red-50 !border-red-200 !text-red-700': notificationType === 'error'
           }">
        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg"
             :class="{
               'text-green-500 bg-green-100': notificationType === 'success',
               'text-red-500 bg-red-100': notificationType === 'error'
             }">
          <svg v-if="notificationType === 'success'" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
          <svg v-else class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mr-3 text-sm font-normal pr-2">{{ notificationMessage }}</div>
        <button @click="showNotification = false" class="mr-auto text-gray-400 hover:text-gray-900 rounded-lg p-1.5 hover:bg-gray-100">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'PackedOrdersList',
  data() {
    return {
      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',
      showPopup: false,
      orders: [],
      selected: [],
      selectAll: false,
      pagination: {
        current_page: 1,
        page_size: 20, // Items per page
        total_items: 0
      },
      filters: {
        id: '',
        status: '',
        search: '',
        date_from: '',
        date_to: '',
        quick_date_filter: ''
      },
      statusLabels: {
        pe: "در انتظار پرداخت",
        pa: "جاری",
        pr: "درحال بسته بندی",
        pc: "بسته بندی شد",
        sh: "ارسال شده",
        de: "تحویل شده",
        ca: "لغو شده",
        re: "مرجوعی"
      },
      quickDateLAbles: {
        today: "امروز",
        yesterday: "دیروز",
        this_month: "این ماه",
      },
    };
  },
  computed: {
    filteredOrders() {

      return this.orders
    },
    totals() {
      return this.filteredOrders.reduce(
          (sum, order) => {
            sum.total_product_quantity += Number(order.total_product_quantity || 0);
            sum.total_price += Number(order.total_price || 0);
            sum.post_price += Number(order.post_price || 0);
            sum.total_discount += Number(order.total_discount || 0);
            sum.final_amount += Number(order.final_amount || 0);
            return sum;
          },
          {
            total_product_quantity: 0,
            total_price: 0,
            post_price: 0,
            total_discount: 0,
            final_amount: 0,
          }
      );
    }
  },
  methods: {
    showNotificationMessage(message, type = 'success') {
      this.notificationMessage = message;
      this.notificationType = type;
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchOrders() {
      let fetch_url = `shop/shopOrderList/all?`
      fetch_url += `status=pc&`
      if (this.filters.id){
        fetch_url += `id=${this.filters.id}&`
      }
      if (this.filters.search){
        fetch_url += `search_value=${this.filters.search}&`
      }
      if (this.filters.quick_date_filter) {
        fetch_url += `quick_date_filter=${this.filters.quick_date_filter}&`
      }
      if (this.filters.date_from){
        fetch_url += `date_from=${this.filters.date_from}&`
      }
      if (this.filters.date_to){
        fetch_url += `date_to=${this.filters.date_to}&`
      }
      fetch_url += `limit=${this.pagination.page_size}&offset=${(this.pagination.current_page - 1) * this.pagination.page_size}&`

      this.request({
        url: this.endpoint(fetch_url),
        method: "get",
        success: data => {
          this.orders = data.results
        }
      })
    },
    printOrders() {
      let print_url = `${this.endpoint('shop/adminOrdersList/html')}?token=${this.token}&`
      print_url += `status=pc&`
      if (this.selected.length > 0){
        print_url += `id__in=${this.selected.join(',')}&`
      }
      if (this.filters.id){
        print_url += `id=${this.filters.id}&`
      }
      if (this.filters.search){
        print_url += `search_value=${this.filters.search}&`
      }
      if (this.filters.quick_date_filter) {
        print_url += `quick_date_filter=${this.filters.quick_date_filter}&`
      }
      if (this.filters.date_from){
        print_url += `date_from=${this.filters.date_from}&`
      }
      if (this.filters.date_to){
        print_url += `date_to=${this.filters.date_to}&`
      }
      print_url += `limit=${this.pagination.page_size}&offset=${(this.pagination.current_page - 1) * this.pagination.page_size}&`

      window.open(print_url)
    },
    toggleSelectAll() {
      this.selected = this.selectAll ? this.filteredOrders.map(o => o.id) : [];
    },
    statusClass(status) {
      console.log(status)
      const map = {
        pe: "  text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full text-[9px]",
        pa: "  text-green-600 bg-green-100  px-2 py-1 rounded-full text-[9px]",
        pr: "  text-blue-600 bg-blue-100 px-2 py-1 rounded-full text-[9px]",
        pc: "  text-indigo-800 bg-indigo-200 px-2 py-1 rounded-full text-[9px]",
        sh: "  text-purple-600 bg-purple-100 px-2 py-1 rounded-full text-[9px]",
        de: "  text-green-600 bg-green-100 px-2 py-1 rounded-full text-[9px]",
        ca: "  text-red-600 bg-red-100 px-2 py-1 rounded-full text-[9px]",
        re: "  text-gray-600 bg-gray-100 px-2 py-1 rounded-full text-[9px]",
      };
      return map[status] || "bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-[9px]";
    },
    formatDate(date) {
      return date ? date.split("T")[0] : "-";
    },
    applyQuickDateFilter() {
      this.filters.date_from = '';
      this.filters.date_to = '';
      this.fetchOrders();
    },
    showConfirmation() {
      this.showPopup = true;
    },
    confirmAction() {
      this.showPopup = false;
      this.changeToProcessing();
    },
    changeToProcessing() {
      this.request({
        url: this.endpoint('shop/bulkChangeStatusToShipped'),
        method: "post",
        data : {order_ids: this.selected},
        success: data => {
          this.showNotificationMessage(`${this.selected.length}  سفارش با موفقیت ارسال شد `, 'success');
          this.fetchOrders()
        }
      })

    }


  },
  mounted() {
    this.fetchOrders();
  }
};
</script>

<style scoped>
table th,
table td {
  text-align: right;
}
</style>

